import { ElementId } from "@/helpers/enums/ElementId.ts";
import { useEffect } from "react";

export const useReservationFinish = (isReserved: boolean) => {
  useEffect(() => {
    if (isReserved) {
      document.getElementById(ElementId.ReservationFinale)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [isReserved]);
};
